import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Money from './money';

const SelectableBox = ({ service, selected, selectService, disabled, unclickable, automationId }) => {
  const classes = classNames('c-tags__item c-tags__service', {
    'is-active': selected,
    'is-disabled': disabled,
    'is-unclickable': unclickable,
  });
  const handleClick = (e) => {
    e.preventDefault();
    selectService(service);
  };

  return (
    <a
      className={classes}
      onClick={handleClick}
      tabIndex={disabled ? -1 : 0}
      data-automation-id={automationId}
    >
      <span className="u-1/1 u-text-trim">{ service.name }</span>
      <span className="c-tags__span u-3/4 u-type--bold">
        &nbsp;<Money cents={service.cost} />&nbsp;/&nbsp;{ service.duration }m
      </span>
    </a>
  );
};

SelectableBox.propTypes = {
  service: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  selectService: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  unclickable: PropTypes.bool,
  automationId: PropTypes.string.isRequired,
};

SelectableBox.defaultProps = {
  disabled: false,
  unclickable: false,
};

export default SelectableBox;
